import type { FontAwesome6ProSolidIconName } from "@react-native-vector-icons/fontawesome6-pro";
import { View } from "react-native";
import { QUICK_REQUEST_ACTIONS } from "../features/home/HomeRequestActions";
import { cn } from "../lib/utils";
import { Icon } from "./ui/icon";

type RoundedIconProps = {
    name: FontAwesome6ProSolidIconName;
    size: "sm" | "md" | "lg";
};

function RoundedIcon({ name, size = "sm" }: RoundedIconProps) {
    return (
        <View
            className={cn(
                "rounded-card bg-background p-2 items-center justify-center",
                size === "sm"
                    ? "w-[32px] h-[32px]"
                    : size === "md"
                      ? "w-[38px] h-[38px]"
                      : "w-[42px] h-[42px]",
            )}
        >
            <Icon
                name={name}
                iconStyle="solid"
                className="shrink-0 text-primary"
                size={size === "sm" ? 14 : size === "md" ? 16 : 20}
            />
        </View>
    );
}

export function UserIcon({ size = "sm" }: Pick<RoundedIconProps, "size">) {
    return <RoundedIcon name="user" size={size} />;
}

export function MedicalIcon({ size = "sm" }: Pick<RoundedIconProps, "size">) {
    return (
        <RoundedIcon name={QUICK_REQUEST_ACTIONS.medical.icon} size={size} />
    );
}

export function PickupIcon({ size = "sm" }: Pick<RoundedIconProps, "size">) {
    return <RoundedIcon name={QUICK_REQUEST_ACTIONS.pickup.icon} size={size} />;
}
export function LeaveIcon({ size = "sm" }: Pick<RoundedIconProps, "size">) {
    return <RoundedIcon name={QUICK_REQUEST_ACTIONS.leave.icon} size={size} />;
}
